import * as React from 'react';

import './arrow-down.scss';

interface ArrowDownProps {
    scrollTo: string;
}

export const scrollToScrollId = (scrollId: string) =>
    document
        .querySelector(`[data-scroll-id="${scrollId}"]`)
        ?.scrollIntoView({ behavior: 'smooth' });

export const ArrowDown = (props: ArrowDownProps) => (
    <button
        className="arrow-down"
        onClick={() => scrollToScrollId(props.scrollTo)}
    />
);
